import { useEffect, useState } from "react";
import { ParticipantEvent, Track } from "livekit-client";

function parseMeta(participant) {
  try { return JSON.parse(participant?.metadata || "{}") || {}; } catch { return {}; }
}

// Shows the participant's profile picture whenever their camera is off /
// unpublished, instead of LiveKit's blank placeholder. Host, co-hosts, guests alike.
export default function StageTileAvatar({ trackRef }) {
  const participant = trackRef?.participant;
  const [, bump] = useState(0);
  useEffect(() => {
    if (!participant) return undefined;
    const re = () => bump((n) => n + 1);
    const evs = [ParticipantEvent.TrackMuted, ParticipantEvent.TrackUnmuted, ParticipantEvent.TrackPublished,
      ParticipantEvent.TrackUnpublished, ParticipantEvent.TrackSubscribed, ParticipantEvent.TrackUnsubscribed, ParticipantEvent.ParticipantMetadataChanged];
    evs.forEach((e) => participant.on(e, re));
    return () => evs.forEach((e) => participant.off(e, re));
  }, [participant]);
  if (!participant) return null;
  const isScreen = trackRef?.source === Track.Source.ScreenShare;
  if (isScreen) return null;
  const pub = participant.getTrackPublication?.(Track.Source.Camera);
  const camOff = !pub || pub.isMuted;
  if (!camOff) return null;
  const { avatar_url } = parseMeta(participant);
  const name = participant.name || "";
  return (
    <div className="absolute inset-0 z-[5] flex flex-col items-center justify-center bg-zinc-950" data-testid={`live-tile-avatar-${participant.identity}`}>
      {avatar_url ? (
        <img src={avatar_url} alt={name} className="w-[38%] max-w-[140px] aspect-square rounded-full object-cover ring-2 ring-white/15" />
      ) : (
        <div className="w-[38%] max-w-[140px] aspect-square rounded-full bg-zinc-800 ring-2 ring-white/10 flex items-center justify-center text-2xl font-display text-zinc-300">
          {(name || "?").slice(0, 1).toUpperCase()}
        </div>
      )}
      <div className="mt-2 text-[11px] text-zinc-400 truncate max-w-[80%]">{name}</div>
      <div className="text-[9px] uppercase tracking-widest text-zinc-600 mt-0.5">Camera off</div>
    </div>
  );
}
